import { render, staticRenderFns } from "./service-view.vue?vue&type=template&id=3d219649&scoped=true&"
import script from "./service-view.vue?vue&type=script&lang=ts&"
export * from "./service-view.vue?vue&type=script&lang=ts&"
import style0 from "./service-view.vue?vue&type=style&index=0&id=3d219649&prod&lang=scss&scoped=true&"
import style1 from "./service-view.vue?vue&type=style&index=1&id=3d219649&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d219649",
  null
  
)

export default component.exports